import type { FormValues } from '../types';
import { InputIDs, CheckboxIDs } from '../types';

/**
 * Fields that should be marked as required
 */
export const requiredFields = Object.fromEntries(
  [
    InputIDs.CUSTOMERID,
    InputIDs.FIRSTNAME,
    InputIDs.LASTNAME,
    InputIDs.STREET,
    InputIDs.HOUSENUMBER,
    InputIDs.CITY,
    InputIDs.POSTALCODE,
    InputIDs.EMAIL,
    CheckboxIDs.TERMS,
  ].map((k) => [k, true]),
);

/**
 * Fields that are used in the form
 */
export const usedFields: FormValues = {
  ...Object.fromEntries(
    [
      InputIDs.FIRSTNAME,
      InputIDs.LASTNAME,
      InputIDs.STREET,
      InputIDs.HOUSENUMBER,
      InputIDs.CITY,
      InputIDs.POSTALCODE,
      InputIDs.MESSAGE,
      InputIDs.EMAIL,
      InputIDs.BIRTHDAY,
      InputIDs.CUSTOMERID,
      CheckboxIDs.TERMS,
    ].map((k) => [k, '']),
  ),
  [InputIDs.SALUTATION]: 'notSpecified',
};

/**
 * Fields that should be prefilled with user's data
 */
export const toPrefill = [
  InputIDs.FIRSTNAME,
  InputIDs.LASTNAME,
  InputIDs.STREET,
  InputIDs.HOUSENUMBER,
  InputIDs.CITY,
  InputIDs.POSTALCODE,
  InputIDs.EMAIL,
  InputIDs.CUSTOMERID,
  InputIDs.BIRTHDAY,
  InputIDs.SALUTATION,
];
